import { setCookie } from 'services/token/helpers'
import Api from '.'

//This method should be universal for calling API
//It simplifies try catch logic and error handling

/**
 * if the token is still valid but the user or cart is deleted from db
 */
const handleTokenError = async (errorCode) => {
    const API = new Api()
    //if the problem is not with token don do anything
    if (!errorCode.includes('TOKEN')) {
        return
    }
    setCookie('token', '')
    /*call method for token regeneration*/
    const response = await API.createToken()
    const { data, status } = response
    if (status !== 200) {
        return
    }
    setCookie('token', data.token)
}

/**
 * Universal function for calling API methods
 */
export async function callApiAsync(methodName, body) {
    const API = new Api()
    try {
        const response = await API[methodName](body)
        const { data, status } = response

        if (status !== 200) {
            return { data: null, error: status }
        }
        //server returns custom errors in data object
        if (data.statuscode >= 500) {
            handleTokenError(data.code)
            return { data: null, error: data.code }
        }

        return { data: data, error: null }
    } catch (error) {
        return { data: null, error: error }
    }
}
